/**
 * Generated by orval v6.31.0 🍺
 * Do not edit manually.
 * Website API
 * The backend API for the website SPA
 * OpenAPI spec version: v1
 */
import {
  useQuery
} from '@tanstack/react-query'
import type {
  QueryClient,
  QueryFunction,
  QueryKey,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query'
import * as axios from 'axios';
import type {
  AxiosError,
  AxiosRequestConfig,
  AxiosResponse
} from 'axios'
import type {
  LayoutResponse
} from './data.schemas'




export const getLayout = (
    segmentationId: number, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<LayoutResponse>> => {
    
    return axios.default.get(
      `/api/segment/${encodeURIComponent(String(segmentationId))}/layout`,options
    );
  }


export const getGetLayoutQueryKey = (segmentationId: number,) => {
    return [`/api/segment/${segmentationId}/layout`] as const;
    }

    
export const getGetLayoutQueryOptions = <TData = Awaited<ReturnType<typeof getLayout>>, TError = AxiosError<unknown>>(segmentationId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLayout>>, TError, TData>>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetLayoutQueryKey(segmentationId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getLayout>>> = ({ signal }) => getLayout(segmentationId, { signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(segmentationId),  staleTime: 900000,  ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getLayout>>, TError, TData> & { queryKey: QueryKey }
}

export type GetLayoutQueryResult = NonNullable<Awaited<ReturnType<typeof getLayout>>>
export type GetLayoutQueryError = AxiosError<unknown>

export const useGetLayout = <TData = Awaited<ReturnType<typeof getLayout>>, TError = AxiosError<unknown>>(
 segmentationId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLayout>>, TError, TData>>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetLayoutQueryOptions(segmentationId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}

export const prefetchGetLayout = async <TData = Awaited<ReturnType<typeof getLayout>>, TError = AxiosError<unknown>>(
 queryClient: QueryClient, segmentationId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLayout>>, TError, TData>>, axios?: AxiosRequestConfig}

  ): Promise<QueryClient> => {

  const queryOptions = getGetLayoutQueryOptions(segmentationId,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}


